import { DeleteExperience, UpdateExperience } from "../../redux/experience";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { ErrorBanner } from "../../components/banner";
import { ExperienceForm } from "./ExpForm";
import { IoTrash } from "react-icons/io5";
import { Loading } from "../../components/loader";
import { Section } from "../../components/section";
import { Text } from "../../components/typography";
import styled from "styled-components";

export const ExperienceEdit = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { loading, error } = useSelector((state) => state.experiences);
  let navigate = useNavigate();

  const onFormSubmit = (values) => {
    if (window.confirm(`Are you sure you want to save your edits?`)) {
      dispatch(UpdateExperience(state.experience.id, values));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/about/experiences");
      }, 500);
    }
  };

  const onDeleteSubmit = () => {
    if (window.confirm(`Are you sure you want to delete this?`)) {
      dispatch(DeleteExperience(state.experience));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/about/experiences");
      }, 500);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Section>
      <SubNav>
        <li onClick={onDeleteSubmit}>
          <IoTrash />
          <Text>Delete</Text>
        </li>
      </SubNav>
      {error && <ErrorBanner text={error} />}
      <ExperienceForm
        initialValues={state.experience}
        onFormSubmit={onFormSubmit}
      />
    </Section>
  );
};

const SubNav = styled.nav`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 2rem;

  li {
    margin-left: 1.5rem;
    display: flex;
    align-items: center;
    color: red;

    p {
      margin: 0;
      padding: 0 0 0 0.5rem;
      color: red;
    }

    &:hover {
      cursor: pointer;
    }
  }
`;
